/**
 * Merge socket/API contact parcial sobre el estado anterior sin perder JSON (0287-G).
 */
export default function mergeContactPartial(prevContact, incoming) {
  if (!incoming || typeof incoming !== "object") return prevContact || {};
  const base = prevContact && typeof prevContact === "object" ? prevContact : {};
  const merged = { ...base, ...incoming };
  const hasOwn = (k) => Object.prototype.hasOwnProperty.call(incoming, k);
  if (!hasOwn("profileData")) merged.profileData = base.profileData;
  if (!hasOwn("aiExtractedData")) merged.aiExtractedData = base.aiExtractedData;
  return merged;
}
